// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28Spc","inner":"Footer_inner__1paoR"};